<template>
	<PageTemplate>
		<template #header>
			<div class="abel photography py-4">
				<h1>My work</h1>
			</div>
		</template>
		<Teleport to="body">
			<Fade>
				<div
					ref="modal"
					class="photo-modal"
					:class="{ 'modal-open': modal_open && image_loaded }"
					v-show="modal_open && image_loaded"
					@click="modal_open = false"
				>
					<div class="photo-modal-content">
						<div class="img">
							<img
								:src="modal_src"
								loading="eager"
								@load="image_loaded = true"
								class=""
							/>
						</div>
					</div>
				</div>
			</Fade>
		</Teleport>
		<div class="abel photography">
			<template v-for="(value, key) in front_page">
				<h2 :id="value.title">{{ value.name }}</h2>
				<PhotoGrid
					src="/assets/portfolio_front_page/thumbnail/"
					:images="value.files"
					@updateModal="updateModal"
				></PhotoGrid>
				<hr />
			</template>
		</div>
	</PageTemplate>
</template>
<script setup>
// import collections from "@/data/collections.json"
// import blogs from "@/data/blogs.json"
import { onMounted, ref, useTemplateRef } from "vue";
import front_page from "../data/front_page.json";
import PhotoGrid from "../components/photography/photogrid.vue";
import PageTemplate from "./PageTemplate.vue";
import Fade from "../components/Transitions/Fade.vue";

const modal = useTemplateRef("modal");
const modal_src = ref("");
const modal_open = ref(false);
const image_loaded = ref(false);
function updateModal(arg) {
	if (modal_src.value !== arg) {
		image_loaded.value = false;
		modal_src.value = arg;
	}
	console.log(arg);
	modal_open.value = true;
}
</script>
